{
  "completed": "Elkészült: ",
  "current": "Jelenlegi: ",
  "notCompleted": "Nincs kész: ",
  "steplist": "Lépések listája"
}
